import React from 'react';
import MapBackdrop from './MapBackdrop';

/** Gemensam ram för inloggning och registrering: bakgrund, logotyp och kort. */
export default function AuthLayout({ title, children }) {
  return (
    <div className="auth-shell">
      <MapBackdrop />

      <div className="auth-card">
        <div className="brand">
          <span className="brand__mark" aria-hidden="true">
            <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
              <path
                className="brand__mark-route"
                d="M 10 38 L 10 26 L 24 26 L 24 14 L 38 14"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle className="brand__mark-dot" cx="10" cy="38" r="4.5" />
              <circle className="brand__mark-dot brand__mark-dot--end" cx="38" cy="14" r="4.5" />
            </svg>
          </span>
          <span className="brand__name">Cruze</span>
        </div>

        <p className="brand__tagline">Rutter, träffar och gänget — på en karta.</p>

        <h2 className="auth-card__title">{title}</h2>

        {children}
      </div>
    </div>
  );
}
